<template>
    <div class="container">
        <div>
            <div class="row" :class="{ 'mb-small': initMemberRegistration }">
                <div class="col-12 col-lg-8">
                    <h1>
                        {{ t('Register.Headline') }}
                    </h1>
                    <h3>{{ t('Register.RegisterTeaser') }}</h3>
                </div>
                <div class="col-12 col-lg-4">
                    <p>
                        <router-link
                            data-qa="register-form-login-button"
                            :to="{ name: 'login', query: { prk, prt } }"
                            class="btn btn-default text-semibold link-icon-next login-link"
                        >
                            <span>{{ t('Register.GoToLogin') }}</span>
                        </router-link>
                    </p>
                </div>
            </div>
            <div
                v-if="invalidPrk"
                class="row mb-small"
                data-qa="invalid-prk-notice"
            >
                <div class="col-8">
                    <div class="crefo-ui-alert info invalid-prk">
                        <div
                            class="mb-small"
                            v-html="t('Register.InvalidPrk')"
                        />
                        <p class="text-small">
                            Correlation-ID:
                            <span data-qa="invalid-prk-correlationid">{{
                                invalidPrkCorrelationid
                            }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="row mb">
                <div class="col-12">
                    <RegisterForm
                        :submitting="user.submitting"
                        :error="user.error"
                        :prk="prk"
                        :prt="prt"
                        :crefonummer="crefonummer"
                        :mitgliedskennung="mitgliedskennung"
                        :hide-smart-signup-explicit="hideSmartSignup"
                        :show-smart-signup-explicit="showSmartSignup"
                        :show-member-choice="showMemberChoice"
                        :init-member-registration="initMemberRegistration"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import RegisterForm from '@/components/forms/register/form'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'

const store = useUserStore()
const router = useRouter()
const { t } = useI18n()

const props = defineProps({
    prk: {
        type: String,
        default: null
    },
    prt: {
        type: String,
        default: null
    },
    crefonummer: {
        type: String,
        default: null
    },
    mitgliedskennung: {
        type: String,
        default: null
    },
    hideSmartSignup: {
        type: Boolean,
        default: false
    },
    showSmartSignup: {
        type: Boolean,
        default: false
    },
    showMemberChoice: {
        type: Boolean,
        default: false
    },
    webtargetConfig: {
        type: Object,
        default: () => ({
            key: null
        })
    },
    title: {
        type: String,
        default: null
    },
    initMemberRegistration: {
        type: Boolean,
        default: false
    }
})
const { getUser: user } = storeToRefs(store)
const invalidPrk = computed(
    () =>
        props.webtargetConfig.key === null &&
            !!props.webtargetConfig?.correlationid
)
const invalidPrkCorrelationid = computed(() =>
    props.webtargetConfig.key === null &&
        props.webtargetConfig?.correlationid
        ? props.webtargetConfig.correlationid
        : ''
)

onMounted(() => {
    watch(
        () => store.user.submitted,
        newValue => {
            if (newValue) {
                if (props.title !== null) {
                    router.push({
                        name: 'register-success',
                        query: {
                            title: props.title,
                            prk: props.prk,
                            prt: props.prt
                        }
                    })
                } else {
                    router.push({
                        name: 'register-success',
                        query: { prk: props.prk, prt: props.prt }
                    })
                }
            }
        }
    )

    if (props.webtargetConfig.key !== null) {
        store.setWebTarget(props.webtargetConfig)
    }

    watch(
        () => store.user.error,
        newValue => {
            if (newValue !== null && typeof newValue != 'undefined') {
                store.toggleDialog({
                    show: !user.value.failureDialog.show,
                    error: newValue,
                    dataQa: 'registerFailure'
                })
            }
        }
    )
})
</script>

<style lang="less">
    .crefo-ui-alert.invalid-prk {
        .alert-close {
            top: 30px;
        }

        p {
            line-height: 18px;

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }
</style>
